export const ACTIVATE_ACCOUNT_PENDING = 'ACTIVATE_ACCOUNT_PENDING';
export const ACTIVATE_ACCOUNT = 'ACTIVATE_ACCOUNT';
export const ACTIVATE_ACCOUNT_ERROR = 'ACTIVATE_ACCOUNT_ERROR';

export const LOGIN_PENDING = 'LOGIN_PENDING';
export const LOGIN_FULFILLED = 'LOGIN_FULFILLED';
export const LOGIN_REJECTED = 'LOGIN_REJECTED';

export const GET_PROFILE_PENDING = 'GET_PROFILE_PENDING';
export const GET_PROFILE_FULFILLED = 'GET_PROFILE_FULFILLED';

export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const PERSISTING_PROFILE = 'PERSISTING_PROFILE';
export const PERSISTED_PROFILE = 'PERSISTED_PROFILE';

export const SHOW_ADDRESS_EDIT_MODAL = 'SHOW_ADDRESS_EDIT_MODAL';
export const HIDE_ADDRESS_EDIT_MODAL = 'HIDE_ADDRESS_EDIT_MODAL';

export const LOGOUT = 'LOGOUT';

export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const PERSISTING_PASSWORD = 'PERSISTING_PASSWORD';
export const PERSISTED_PASSWORD = 'PERSISTED_PASSWORD';
export const PERSIST_PASSWORD_REJECTED = 'PERSIST_PASSWORD_REJECTED';
export const UPDATE_PASSWORD_RECOVERY = 'UPDATE_PASSWORD_RECOVERY';
export const UPDATE_PASSWORD_RESET = 'UPDATE_PASSWORD_RESET';

export const UPDATE_REGISTERVIEWMODEL = 'UPDATE_REGISTERVIEWMODEL';
export const PERSISTING_REGISTERVIEWMODEL = 'PERSISTING_REGISTERVIEWMODEL';
export const PERSISTED_REGISTERVIEWMODEL = 'PERSISTED_REGISTERVIEWMODEL';
export const PERSIST_REGISTERVIEWMODEL_REJECTED = 'PERSIST_REGISTERVIEWMODEL_REJECTED';

export const SENDING_EMAIL_CONFIRMATION_EMAIL = 'SENDING_EMAIL_CONFIRMATION_EMAIL';
export const SENT_EMAIL_CONFIRMATION_EMAIL = 'SENT_EMAIL_CONFIRMATION_EMAIL';
export const SENT_EMAIL_CONFIRMATION_REJECTED = 'SENT_EMAIL_CONFIRMATION_REJECTED';

export const SENDING_PASSWORD_RECOVERY = 'SENDING_PASSWORDRECOVERY';
export const SENT_PASSWORD_RECOVERY = 'SENT_PASSWORDRECOVERY';
export const SENT_PASSWORD_RECOVERY_REJECTED = 'SENT_PASSWORDRECOVERY_REJECTED';

export const PERSISTING_EMAIL_CONFIRMATION = 'PERSISTING_EMAIL_CONFIRMATION';
export const PERSISTED_EMAIL_CONFIRMATION = 'PERSISTED_EMAIL_CONFIRMATION';
export const PERSISTED_EMAIL_CONFIRMATION_REJECTED = 'PERSISTED_EMAIL_CONFIRMATION_REJECTED';

export const PERSISTING_PASSWORDRESET = 'PERSISTING_PASSWORDRESET';
export const PERSISTED_PASSWORDRESET = 'PERSISTED_PASSWORDRESET';
export const PERSISTED_PASSWORDRESET_REJECTED = 'PERSISTED_PASSWORDRESET_REJECTED';

export const RESET_ACCOUNT_ERRORS = 'RESET_ACCOUNT_ERRORS';

export const UPDATE_LANGUAGE = 'UPDATE_LANGUAGE';

export const PERSIST_PROFILE_ADDRESS_PENDING = 'PERSIST_PROFILE_ADDRESS_PENDING';
export const PERSIST_PROFILE_ADDRESS_FULFILLED = 'PERSIST_PROFILE_ADDRESS_FULFILLED';
export const PERSIST_PROFILE_ADDRESS_REJECTED = 'PERSIST_PROFILE_ADDRESS_REJECTED';

export const CREATE_PROFILE_ADDRESS_PENDING = 'CREATE_PROFILE_ADDRESS_PENDING';
export const CREATE_PROFILE_ADDRESS_FULFILLED = 'CREATE_PROFILE_ADDRESS_FULFILLED';
export const CREATE_PROFILE_ADDRESS_REJECTED = 'CREATE_PROFILE_ADDRESS_REJECTED';
